import { render, staticRenderFns } from "./page-services.vue?vue&type=template&id=44c8eddc&"
import script from "./page-services.vue?vue&type=script&lang=js&"
export * from "./page-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports